import React from 'react';
import './TemaPrekidac.css';

/* Prekidač teme dan/noć — jedan za celu aplikaciju (Administracija → Korisnik i
   podešavanja chata). Ranije je chat imao svoju zelenu kvačicu, a Administracija
   ovaj „komad neba"; sada je isti na oba mesta, pa izgled i ponašanje ne mogu da
   se raziđu.

   Sve crta CSS (TemaPrekidac.css) — prazni <span>-ovi su samo nosači oblika.
   `onToggle(event)` dobija događaj, jer applyThemeWithReveal otkriva novu temu
   krugom iz tačke klika. */
const TemaPrekidac = ({ dark, onToggle, ariaLabel, className = '' }) => (
    <button
        type="button"
        role="switch"
        aria-checked={dark}
        aria-label={ariaLabel}
        className={`tema-toggle${dark ? ' on' : ''}${className ? ` ${className}` : ''}`}
        onClick={onToggle}
    >
        {/* Nebo seče svoj sadržaj (oblaci, zvezde, padalica ostaju unutar
            pilule), a sunce sme da zasija preko ivice. */}
        <span className="tema-nebo">
            <span className="tema-oblak tema-oblak-1" />
            <span className="tema-oblak tema-oblak-2" />
            <span className="tema-zvezda tema-zvezda-1" />
            <span className="tema-zvezda tema-zvezda-2" />
            <span className="tema-zvezda tema-zvezda-3" />
            <span className="tema-zvezda tema-zvezda-4" />
            <span className="tema-zvezda tema-zvezda-5" />
            <span className="tema-padalica" />
        </span>
        <span className="tema-toggle-knob">
            <span className="tema-zraci" />
            <span className="tema-krater tema-krater-1" />
            <span className="tema-krater tema-krater-2" />
            <span className="tema-krater tema-krater-3" />
        </span>
    </button>
);

export default TemaPrekidac;
